<template>
  <div id="app">
    <router-view/>
    <modals-container />
  </div>
</template>
<script>
require('../node_modules/c3/c3.min.css')
require('../node_modules/leaflet/dist/leaflet.css')
import 'vue-date-pick/dist/vueDatePick.css'
export default {
  name: 'app'
}
</script>
<style>
html, body {
  margin: 0;
  height: 100%;
  background: #bfb6b7;
}
#app {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: small;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #242424;
  background: white;
  margin: 0 0;
  min-height: 100%;
}

@media only screen and (min-width: 680px) {    
  #app {
    margin: 0 40px;
  }
}
.login #app {
  background: #bfb6b7;
}
.leaflet-popup {
  pointer-events: none;
}
.leaflet-popup.pft-pop > .leaflet-popup-content-wrapper {
  box-shadow: none;
  background-color: transparent;
}
.leaflet-popup.pft-pop .c3-tooltip {
  opacity: 1;
}
.leaflet-popup.pft-pop > .leaflet-popup-close-button,
.leaflet-popup.pft-pop > .leaflet-popup-tip-container {
  display: none;
}
.leaflet-left .leaflet-control {
  margin-left: 25px;
}
.pft-city-text {
  pointer-events: none;
  display: inline-block;
  text-anchor: middle;
  height: auto !important;
}
.pft-city-text span {
  pointer-events: none;
  display: inline-block;
  padding: 0px 4px;
  border-radius: 3px;
  font-weight: 500;
  background: rgba(255,255,255, .89);
  width: max-content !important;
  transform: translateX(-90%)
}
.btn {
  background: hsla(350, 80%, 54%, 1);
  border:0;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 5px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
}
.btn:hover {
  cursor: pointer;
  background-color: hsla(350, 80%, 34%, 1);
}
.btn:active {
	/* position:relative; */
	transform:translate(0,1px);
}
.btn.med {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 5px 8px;
}
.btn.sml {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 3px 8px;
}
.btn.secondary {
  background: hsla(39, 89%, 60%, 1)
}
.btn.secondary:hover {
  background: hsla(39, 89%, 45%, 1)
}
.btn.creation {
  background: hsla(99, 31%, 35%, 1)
}
.btn.creation:hover {
  background: hsla(99, 31%, 25%, 1)
}
.btn.inactive {
  background: hsla(0, 5%, 80%, 1);
}
.btn.inactive:hover {
  cursor: default;
}
.btn.tertiary {
  background: hsla(0, 5%, 80%, 1);
}
.btn.tertiary:hover {
  background: hsla(0, 5%, 70%, 1);
}

.btn-img {
  border: 0;
  padding: 0;
  position: relative;
  width: 40px;
  height: 40px;
  transition: all 0.3s ease-in-out;
  background: transparent;
}
.btn-img::after {
  width: 40px;
  height: 40px;
  transition: all 0.3s ease-in-out;
  content: ' ';
  display: block;
  background: #e72b4a;
  top:-1px;
  left:-1px;
  position: absolute;
}
.btn-img.med {
  width: 30px;
  height: 30px;
}
.btn-img.med::after {
  width: 30px;
  height: 30px;
}
.btn-img:hover::after {
  cursor: pointer;
  background-color: hsla(347, 100%, 35%, 1);
}
.btn-img.btn-minus::after {
  -webkit-mask: url(/static/images/close-solid.svg) no-repeat center;
  mask: url(/static/images/close-solid.svg) no-repeat center;
}
.btn-img.btn-minus {
  border-radius: 50%;
}

.btn-img.btn-cancel::after {
  -webkit-mask: url(/static/images/close.svg) no-repeat center;
  mask: url(/static/images/close.svg) no-repeat center;
  background-color: hsla(0, 0%, 60%, 1);
}
.btn-img.btn-cancel:hover::after {
  background-color: hsla(0, 0%, 20%, 1);
}
.btn-img.btn-calendar {
  width: 18px;
  height: 18px;
}

.btn-img.btn-calendar::after {
  -webkit-mask: url(/static/images/calendar.svg) no-repeat center;
  mask: url(/static/images/calendar.svg) no-repeat center;
  background-color: hsla(0, 0%, 60%, 1);
  width: 18px;
  height: 16px;
  top:4px;
  left:0px;
}
.btn-img.btn-calendar:hover::after {
  background-color: hsla(0, 0%, 20%, 1);
}
.prob-tag {
  padding: 2px 4px;
  text-transform: uppercase;
  font-size: 0.5rem;
  background: red;
  border-radius: 3px;
  margin-right: 4px;
  color: white;
  font-weight: bold;
  border: 0;
  transition: all 0.3s ease-in-out;
}
/* button.prob-tag {
  cursor: pointer;
}
 button.prob-tag:hover {
  margin-left: 2px;
} */
.prob-bg-18 {
  background: rgb(31, 119, 180);
}
.prob-bg-12 {
  background: rgb(255, 127, 14);
}
.prob-bg-20 {
  background: rgb(44, 160, 44);
}
.prob-bg-14 {
  background: rgb(214, 39, 40);
}
.prob-bg-15 {
  background: rgb(148, 103, 189);
}
.prob-bg-16 {
  background: rgb(140, 86, 75);
}
.prob-bg-17 {
  background: rgb(227, 119, 194);
}
.prob-bg-19 {
  background: rgb(127, 127, 127);
}
.prob-bg-13 {
  background: rgb(188, 189, 34);
}
.prob-bg-21 {
  background: rgb(23, 190, 207);
}
.prob-bg-22 {
  background: rgb(0, 94, 152);
}
.prob-bg-23 {
  background: rgb(217, 95, 0);
}
.prob-bg-24 {
  background: rgb(0, 141, 37);
}

.status--1 {
  background:rgb(127, 127, 127);
}
.status-0 {
  background: hsla(17, 99%, 65%, 1);
}
.status-1 {
  background: hsla(29, 100%, 66%, 1);
}
.status-2 {
  background: hsla(43, 100%, 66%, 1);
}
.status-3 {
  background: #7bc67b;
}
.status-4 {
  background: #009345;
}
.status-5 {
  background: hsla(177, 88%, 35%, 1);
}
.status-6 {
  background: hsla(207, 82%, 42%, 1);
}
.status-7 {
  background: hsla(229, 66%, 37%, 1);
}
.status-8 {
  background: #542287;
}
.status-9 {
  background: hsla(320, 56%, 48%, 1);
}
.status-10 {
  background: #abd579;
}
.status-14 {
  background: #38b97c;
}
.status-11 {
  background: #34b653;
}
.status-12 {
  background: #00a757;
}
.status-13 {
  background: #752287;
}
.status-15 {
  background:#d37028;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  opacity: 1;
  z-index: 10;
  margin: -50px 0 0 -50px;
  font-size: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(0, 0, 0, 0.2);
  border-right: 1.1em solid rgba(0, 0, 0, 0.2);
  border-bottom: 1.1em solid rgba(0, 0, 0, 0.2);
  border-left: 1.1em solid #000;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
} 
.modal .inner {
  position: fixed;
  padding: 40px 20px 20px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
}
.modal .close {
  display: inline-block;
  position: absolute;
  clear: both;
  margin-bottom: 10px;
  top: 10px;
  right: 20px;
  font-weight: bold;
  cursor: pointer;
}
.modal img {
  height: 400px;
  display: block;
  width: auto;
}
@media only screen and (min-width: 680px) {   
  .modal img {
    height: 600px;
  }
}
</style>
